import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { CompanySelectComponent } from './login/company-select/company-select.component';

import { DashboardComponent } from './dashboard/dashboard.component';
import { PartnersComponent } from './dashboard/partners/partners.component';
import { UserComponent } from './dashboard/user/user.component';
import { UsersmenuComponent } from './dashboard/usersmenu/usersmenu.component';

import { NewreceptionComponent } from './dashboard/newreception/newreception.component';
import { ReceptionsComponent } from './dashboard/receptions/receptions.component';
import { InvoicesComponent } from './dashboard/invoices/invoices.component';
import { MycompanyComponent } from './dashboard/mycompany/mycompany.component';
import { NewinvoiceComponent } from './dashboard/newinvoice/newinvoice.component';
import { SpendingsComponent } from './dashboard/spendings/spendings.component';
import { StockBalanceComponent } from './dashboard/stock-balance/stock-balance.component';
import { CashcollectionsComponent } from './dashboard/cashcollections/cashcollections.component';
import { PaymentsComponent } from './dashboard/payments/payments.component';
import { NewpurchasecontractComponent } from './dashboard/newpurchasecontract/newpurchasecontract.component';
import { PurchasecontractsComponent } from './dashboard/purchasecontracts/purchasecontracts.component';
import { StatsComponent } from './dashboard/stats/stats.component';
import { TaxationreportComponent } from './dashboard/taxationreport/taxationreport.component';
import { TaxationsettingsComponent } from './dashboard/taxationsettings/taxationsettings.component';
import { AddnewcompanyComponent } from './dashboard/addnewcompany/addnewcompany.component';
import { ExternalComponent } from './external/external.component';
import { InvoiceComponent } from './external/invoice/invoice.component';
import { ProductsComponent } from './dashboard/products/products.component';
import { ApisettingsComponent } from './dashboard/apisettings/apisettings.component';
import { ActivitylogComponent } from './dashboard/activitylog/activitylog.component';
import { DocumentComponent } from './dashboard/document/document.component';
import { ManagementComponent } from './management/management.component';
import { MysettingsComponent } from './management/mysettings/mysettings.component';
import { AppsettingsComponent } from './management/appsettings/appsettings.component';
import { TasksComponent } from './management/tasks/tasks.component';
import { NewtaskComponent } from './management/newtask/newtask.component';
import { ProductsinformationComponent } from './management/productsinformation/productsinformation.component';
import { ConfigurationsComponent } from './management/configurations/configurations.component';
import { PartnersdataComponent } from './management/partnersdata/partnersdata.component';
import { ProductsdataimportComponent } from './management/productsdataimport/productsdataimport.component';
import { PasswordrecoveryComponent } from './login/passwordrecovery/passwordrecovery.component';
import { MFAComponent } from './login/mfa/mfa.component';
import { StockComponent } from './management/stock/stock.component';
import { B2bComponent } from './b2b/b2b.component';
import { HomeComponent } from './b2b/home/home.component';
import { ProfileComponent } from './b2b/profile/profile.component';
import { CreateShippingLabelComponent } from './management/create-shipping-label/create-shipping-label.component';
import { TrackShippingLabelComponent } from './management/track-shipping-label/track-shipping-label.component';
import { CartComponent } from './b2b/cart/cart.component';
import { ListpricesComponent } from './b2b/listprices/listprices.component';
import { OfferRequestConfirmationComponent } from './b2b/offer-request-confirmation/offer-request-confirmation.component';
import { MyOfferRequestsComponent } from './b2b/my-offer-requests/my-offer-requests.component';
import { OfferRequestsComponent } from './management/offer-requests/offer-requests.component';
import { ShipmentsComponent } from './management/shipments/shipments.component';
import { NeworderconfirmationComponent } from './management/neworderconfirmation/neworderconfirmation.component';
import { ProductspricecontrolComponent } from './management/productspricecontrol/productspricecontrol.component';
import { ErrorComponent } from './b2b/error/error.component';
import { MyInvoicesComponent } from './b2b/my-invoices/my-invoices.component';
import { ListpricesspreadsheetComponent } from './b2b/listpricesspreadsheet/listpricesspreadsheet.component';
import { MyOrdersComponent } from './b2b/my-orders/my-orders.component';
import { TransportersComponent } from './dashboard/transporters/transporters.component';
import { EFacturaReceivedInvoicesComponent } from './dashboard/efactura-received-invoices/efactura-received-invoices.component';
import { RegisterComponent } from './login/register/register.component';
import { UpcomingPaymentsComponent } from './dashboard/upcoming-payments/upcoming-payments.component';
import { UpcomingCashCollectionsComponent } from './dashboard/upcoming-cash-collections/upcoming-cash-collections.component';
import { ListPricesAgGridComponent } from './b2b/list-prices-ag-grid/list-prices-ag-grid.component';
import { B2btrackingComponent } from './management/b2btracking/b2btracking.component';
import { PartnersTransitItemsComponent } from './management/partners-transit-items/partners-transit-items.component';
import { CreateNewQuotationComponent } from './management/create-new-quotation/create-new-quotation.component';
import { OffersComponent } from './management/offers/offers.component';
import { OrderConfirmationsComponent } from './management/order-confirmations/order-confirmations.component';
import { AcceptOfferComponent } from './b2b/accept-offer/accept-offer.component';
import { PurchaseOrdersComponent } from './management/purchase-orders/purchase-orders.component';
import { OfferRequestsIndividualItemsComponent } from './management/offer-requests-individual-items/offer-requests-individual-items.component';
import { RequestedIndividualItemsComponent } from './b2b/requested-individual-items/requested-individual-items.component';
import { ClaimComponent } from './b2b/claim/claim.component';
import { ClaimsComponent } from './management/claims/claims.component';
import { ClientclaimComponent } from './external/clientclaim/clientclaim.component';
import { ProductsSpecialPricesComponent } from './management/products-special-prices/products-special-prices.component';
import { CarriersComponent } from './management/carriers/carriers.component';
import { PartnerComponent } from './external/partner/partner.component';
import { UsersComponent } from './management/users/users.component';
import { OrderConfirmationNewComponent } from './management/order-confirmation-new/order-confirmation-new.component';
import { NewPurchaseOrderComponent } from './management/new-purchase-order/new-purchase-order.component';

const routes: Routes = [

{path: '', redirectTo: 'login', pathMatch: 'full' },
{path:'login', component:LoginComponent},
{path:'login/success/company/select', component:CompanySelectComponent},
{path:'password/reset', component:PasswordrecoveryComponent},
{path:'login/MFA', component:MFAComponent},
{path:'b2b/register', component:RegisterComponent},
{path:'external', component:ExternalComponent,
      children:[
            { path: 'view/invoice', component: InvoiceComponent },
            { path: 'password/reset', component: StatsComponent },
            { path: 'claim', component: ClientclaimComponent },
            { path: 'partner', component: PartnerComponent },]},
      {path:'B2B/accept/offer', component:AcceptOfferComponent},
      {path:'dashboard', component:DashboardComponent,
      children: [
      { path: 'stats', component: StatsComponent },
      { path: 'partners', component: PartnersComponent },
      { path: 'manage/products', component: ProductsComponent },
      { path: 'user/details', component: UserComponent },
      { path: 'users/menu', component: UsersmenuComponent },
      { path: 'purchases/reception', component: NewreceptionComponent },
      { path: 'purchases/reception/:id', component: NewreceptionComponent },
      { path: 'purchases/contract', component: NewpurchasecontractComponent },
      { path: 'purchases/contract/:id', component: NewpurchasecontractComponent },
      { path: 'documents/receptions', component: ReceptionsComponent },
      { path: 'documents/invoices', component: InvoicesComponent },
      { path: 'documents/purchasecontracts', component: PurchasecontractsComponent },
      { path: 'settings/mycompany', component: MycompanyComponent },
      { path: 'settings/company/taxation/settings', component: TaxationsettingsComponent },
      { path: 'settings/transporters', component: TransportersComponent },
      { path: 'sales/invoice', component: NewinvoiceComponent },
      { path: 'sales/invoice/:id', component: NewinvoiceComponent },
      { path: 'sales/cashcollections', component: CashcollectionsComponent },
      { path: 'purchases/spendings', component: SpendingsComponent },
      { path: 'purchases/payments', component: PaymentsComponent },
      { path: 'reports/stockbalance', component: StockBalanceComponent },
      { path: 'reports/taxation', component: TaxationreportComponent },
      { path: 'companies/add', component: AddnewcompanyComponent },
      { path: 'settings/api', component: ApisettingsComponent },
      { path: 'activity/log', component: ActivitylogComponent },
      { path: 'document/view', component: DocumentComponent },
      { path: 'documents/EFactura/Received/Invoices', component: EFacturaReceivedInvoicesComponent },
      { path: 'purchases/upcoming/payments', component: UpcomingPaymentsComponent },
      { path: 'sales/upcoming/cashcollections', component: UpcomingCashCollectionsComponent },
]
},
{path:'management', component:ManagementComponent, children: [
      { path: 'personal/settings', component: MysettingsComponent },
      { path: 'application/settings', component: AppsettingsComponent },
      { path: 'tasks', component: TasksComponent },
      { path: 'newtask', component: NewtaskComponent },
      { path: 'products/information', component: ProductsinformationComponent },
      { path: 'configuration/settings', component: ConfigurationsComponent },
      { path: 'partners/data', component: PartnersdataComponent },
      { path: 'products/data/import', component: ProductsdataimportComponent },
      { path: 'products/stock', component: StockComponent },
      { path: 'products/price/control/settings', component: ProductspricecontrolComponent },
      { path: 'track/shipment', component: TrackShippingLabelComponent },
      { path: 'new/shipment', component: CreateShippingLabelComponent },
      { path: 'offer/requests', component: OfferRequestsComponent },
      { path: 'shipments', component: ShipmentsComponent },
      { path: 'order/confirmation/new', component: NeworderconfirmationComponent },
      { path: 'partners/b2b/tracking', component: B2btrackingComponent },
      { path: 'partners/transit/items', component: PartnersTransitItemsComponent },
      { path: 'quotations/new', component: CreateNewQuotationComponent },
      { path: 'offers', component: OffersComponent },
      { path: 'order/confirmations', component: OrderConfirmationsComponent },
      { path: 'purchase/orders', component: PurchaseOrdersComponent },
      { path: 'individual/items/requests', component: OfferRequestsIndividualItemsComponent },
      { path: 'claims', component: ClaimsComponent },
      { path: 'products/special/prices', component: ProductsSpecialPricesComponent },
      { path: 'carriers', component: CarriersComponent },
      { path: 'settings/users', component: UsersComponent },
      { path: 'order/new/order/confirmation', component: OrderConfirmationNewComponent },
      { path: 'new/purchase/order', component: NewPurchaseOrderComponent },
]},
      {path:'B2B', component:B2bComponent, children: [
      { path: '', component: HomeComponent },
      { path: 'store/cart', component: CartComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'pricelist/ag', component: ListpricesComponent },
      { path: 'pricelist', component: ListpricesspreadsheetComponent },
      { path: 'search', component: ListPricesAgGridComponent },
      { path: 'store/cart/offer/reqest/confirmation', component: OfferRequestConfirmationComponent },
      { path: 'my/requests', component: MyOfferRequestsComponent },
      { path: 'error', component: ErrorComponent },
      { path: 'my/invoices', component: MyInvoicesComponent },
      { path: 'my/orders', component: MyOrdersComponent },
      { path: 'requested-individual-items', component: RequestedIndividualItemsComponent },
      { path: 'support-center', component: ClaimComponent },
]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
